/*
  * 人员
  * */
export const GETORGANIZATIONLIST = 'GETORGANIZATIONLIST'
export const ADDORGANIZATIONLIST = 'ADDORGANIZATIONLIST'
export const EDITORGANIZATIONLIST = 'EDITORGANIZATIONLIST'
export const DELETEORGANIZATION = 'DELETEORGANIZATION'
/*
* 教师
* */
export const GETTEACHER = 'GETTEACHER'
export const EXPORTEACHER = 'EXPORTEACHER'
export const ADDTEACHER = 'ADDTEACHER'
export const UPDATETEACHER = 'UPDATETEACHER'
export const DELETETEACHER = 'DELETETEACHER'
/*
  * 学生
  * */
export const GETSTUDENT = 'GETSTUDENT'
export const EXPORTSTUDENT = 'EXPORTSTUDENT'
export const ADDSTUDENT = 'ADDSTUDENT'
export const UPDATESTUDENT = 'UPDATESTUDENT'
export const DELETESTUDENT = 'DELETESTUDENT'
export const RISEGRADE = 'RISEGRADE'
export const ADDGRADE = 'ADDGRADE'
export const GETSTUSELECTLIST = 'GETSTUSELECTLIST'
export const GETSTUSELECTLISTFOREXPEND = 'GETSTUSELECTLISTFOREXPEND'
/*
* 毕业生
* */
export const GETSGRADUATE = 'GETSGRADUATE'
/*
  * 角色管理
  * */
export const GETSELECTROLE = 'GETSELECTROLE'
export const CHECKUSER = 'CHECKUSER'
export const GETSELECTTAGS = 'GETSELECTTAGS'
/*
  * 教师/班级关系
  * */
export const GETCLASSTEACHERSET = 'GETCLASSTEACHERSET'
export const GETTEACHERSELECT = 'GETTEACHERSELECT'
export const UPDATECLASSTEACHERSET = 'UPDATECLASSTEACHERSET'
export const PRINT = 'PRINT'
export const batchGetTaskDetails = 'batchGetTaskDetails'
export const printAccept = 'printAccept'



// WEBPACK FOOTER //
// ./src/store/userData/types.js